import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';

import {
  getCurrentMeet,
  getLifter,
  getScreenMedia
} from 'selectors';
import {
  getDivisionDoc,
  getLifterAwardsWeightClassDoc
} from 'util/lifterHelper';
import ResultsTable from 'app/meets/results/ResultsTable';

class LifterResults extends Component {

  render() {
    const { meet, lifter, media } = this.props;
    const divisions = _.map(lifter.divisions, (lifterDivision) => {
      const divisionDoc =  {...getDivisionDoc(lifterDivision.divisionId, meet)};
      divisionDoc.weightClasses = _.filter(divisionDoc.weightClasses, (w) => {
        const lifterWeightClass = getLifterAwardsWeightClassDoc(meet, lifter, lifterDivision);
        return lifterWeightClass && lifterWeightClass._id === w._id;
      });

      return divisionDoc;
    });

    return (
      <div className="lifter-results">
        <ResultsTable meet={meet} divisions={divisions} media={media} />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props),
    lifter: getLifter(state, props),
    media: getScreenMedia(state, props)
  };
};

const actions = {};

export default withRouter(connect(mapStateToProps, actions)(LifterResults));
